import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useChatOptions } from "MessagingV2/providers/ChatOptionsProvider";
import { ATTACHMENT_TYPES, CHAT_SCREEN_MODE } from "MessagingV2/modules/Utils";

import {
  MEDIA_DIMENSIONS_PER_VIEW_MODE,
  SQUARE_THUMBNAIL_RESOLUTION,
} from "../Utils";
import MediaWrapper, { MEDIA_VISIBILITY } from "../MediaWrapper";
import classes from "./TripleVisualMediaContainer.scss";

const TripleVisualMediaContainer = props => {
  const { attachments, onMediaClick } = props;
  const { screenMode } = useChatOptions();

  const containerClasses = classNames(classes.container, {
    [classes.widgetContainer]: screenMode === CHAT_SCREEN_MODE.WIDGET,
  });

  const dimensions = {
    height: MEDIA_DIMENSIONS_PER_VIEW_MODE[screenMode].height,
    width: MEDIA_DIMENSIONS_PER_VIEW_MODE[screenMode].width,
  };

  return (
    <div className={containerClasses}>
      {_.map(attachments, attachment => {
        const { type } = attachment;
        const isVideo = type === ATTACHMENT_TYPES.VIDEO;

        return (
          <MediaWrapper
            {...dimensions}
            key={attachment.id}
            onMediaClick={onMediaClick}
            iconVisibility={isVideo ? MEDIA_VISIBILITY.PERSISTENT : undefined}
            attachment={attachment}
            imgClassName={classes.image}
            thumbnailResolution={SQUARE_THUMBNAIL_RESOLUTION}
          />
        );
      })}
    </div>
  );
};

TripleVisualMediaContainer.propTypes = {
  onMediaClick: PropTypes.func.isRequired,
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TripleVisualMediaContainer;
